var SessionToken = require('session/session-token');

function readToken(input) {
    return new SessionToken(input.readMany(SessionToken.TOKEN_LENGTH));
}

module.exports = readToken;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/session/session-token-deserialiser.js
// module id = 1073
// module chunks = 1